<template>
  <div class="edit-tag-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="center"
        ref="form"
        :model="params"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="标签名:" prop="name">
          <el-input v-model="params.name" size="small" clearable disabled></el-input>
        </el-form-item>
        <el-form-item label="种类" prop="types">
          <el-select v-model="params.types" placeholder="请选择" clearable>
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="标签排序:" prop="sortCode">
          <el-input v-model.number="params.sortCode" size="small"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model.number="params.remark" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开关" prop="enable">
          <el-switch v-model="params.enable" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm()" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {validatorIndex} from "@/utils/validator";
import API from "@/api";
// import baseConfig from '@/utils/serverUrlConfig'
export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      type: "",

      // 提交状态
      flag: false,
      value: false,
      // 表单数据
      params: {
        name: "",
        sortCode: 0,
        types: 0,
        enable: true,
        remark: "",
        id: "",
      },
      value1: "",
      options: [
        {
          value: 0,
          label: "默认",
        },
        {
          value: 1,
          label: "最热",
        },
        {
          value: 2,
          label: "最新",
        },
      ],
      // 表单验证规则
      rules: {
        name: [{ required: true, message: "请输入标签名称", trigger: "blur" }],
        sortCode: [
          { required: true, message: "请输入排序(整数))", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          // if (this.type === 'add') {
          this.addTags();
          // } else {
          //   this.editTag()
          // }
        } else {
          return false;
        }
      });
    },
    //推荐
    addTags() {
      API.addRecmdList(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "推荐成功",
              type: "success",
            });
            this.$emit("handlerTagList");
          } else {
            this.$message.error("推荐失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    //编辑标签
    // editTag() {
    //   let params = Object.assign(this.params, { id: this.id })
    //   API.editRecmdList(params).then(res => {
    //     if (res.code === 200) {
    //       this.$message({
    //         message: '编辑成功',
    //         type: 'success'
    //       });
    //       this.$emit('handlerTagList')
    //     } else {
    //       this.$message.error('编辑失败');
    //     }
    //     this.handleClose();
    //     this.flag = false
    //   }).catch(() => {
    //     this.handleClose();
    //     this.flag = false
    //   })
    // },
    //关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        name: "",
        sortCode: 0,
        types: 0,
        enable: true,
        remark: "",
      };
    },
    //打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      this.type = type;
      this.params.id = data.id;
      if (data.enable === "关闭") {
        this.params.enable = false;
      } else {
        this.params.enable = true;
      }
      this.title = "推荐标签";
      this.params.name = data.name;
      switch (this.params.types) {
        case "默认":
          this.params.types = 0;
          break;
        case "最热":
          this.params.types = 1;
          break;
        case "最新":
          this.params.types = 2;
          break;
      }
      this.params.sortCode = data.sortCode;
      this.params.remark = data.remark;
    },
  },
};
</script>

<style lang="scss" >
.edit-tag-box {
  .el-dialog {
    margin-top: 100px !important;
  }
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>

